import { useCompany } from "../contexts/CompanyContext"
import { useUser } from "../contexts/UserContext"
import { useConfig } from "../contexts/ConfigContext"
import React, { useEffect } from "react"
import { ApartmentOutlined, PoweroffOutlined, SettingOutlined, UnorderedListOutlined, UserOutlined } from "@ant-design/icons"
import { ItemType } from "antd/es/menu/interface"
import { baseURL } from "../config/const"
import { TopBar as SharedTopBar } from "@ryo/ui"
import LogoutModal from "./LogoutModal"

function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout>;
  return function (...args: Parameters<T>) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

const fullOptions:ItemType[] = [
  {
    key: 'my_user',
    label: 'Mi usuario',
    disabled: true,
  },
  {
    type: 'divider',
  },
  {
    key: 'config_profile',
    label: 'Perfil',
    extra: '⌘P',
    icon: <UserOutlined/>
  },
  {
    key: 'module_settings',
    label: 'Configuraciones',
    icon: <SettingOutlined />,
    extra: '⌘C',
  },
  {
    key: 'activity_log',
    label: 'Registro de actividad',
    icon: <UnorderedListOutlined />,
    extra: '⌘R',
  },
  {
    key: 'change_session',
    label: 'Cambiar sesión',
    icon: <ApartmentOutlined />,
    extra: '⌘c',
  },
  {
    type: 'divider',
  },
  {
    key: 'exit_option',
    label: 'salir',
    icon: <PoweroffOutlined />,
    extra: '⌘S',
  },
]

function TopBar(){
  const {company} = useCompany()
  const {config,updateConfig} = useConfig()
  const {user} = useUser()

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      updateConfig({sideVisible:!isMobile,isMobile,sideCollapsed:isMobile})
    };
    const debouncedResize = debounce(handleResize, 200);
    debouncedResize()
    window.addEventListener("resize", debouncedResize);
    return () => window.removeEventListener("resize", debouncedResize);
  }, []);

  const toggleMobileMenu = (e:any) => {
    e.preventDefault()
    if(!config.sideVisible && config.isMobile){
      updateConfig({sideCollapsed:true})
    }
    updateConfig({sideVisible:!config.sideVisible})
  };

  const onUserItem = (key: string) => {
    switch(key){
      case "change_session":
        globalThis.location.href = baseURL
        break
      case "exit_option":
        updateConfig({showLogout:true})
        break
      default:
        alert("Modulo en construccion...")
    }
  };

  const onModuleItem = (key: string) => {
    const selectedModule = company.current.modules.find((__,index) => index.toString() === key)
    const current = document.location.origin
    if(selectedModule && (current !== selectedModule.path)){
      globalThis.location.href = selectedModule.path + "?company=" + company.current.uid
    }
  };

  const itemsUser = fullOptions.filter((el,i) => 
    el?.type === "divider" || 
    i === 0 || 
    user.permissions.views.join().includes(el?.key?.toString() || "***")
  )

  const onCompanyChange = (key: string) => {
    if(key !== company.current.uid){
      globalThis.location.href = globalThis.location.origin + '?company=' + key;
    }
  };

  return (
    <>
      <SharedTopBar 
        user={user}
        company={company as any}
        config={config}
        userMenuItems={itemsUser}
        onToggleMobileMenu={toggleMobileMenu}
        onCompanyChange={onCompanyChange}
        onModuleClick={onModuleItem}
        onUserItemClick={onUserItem}
      />
      <LogoutModal/>
    </>
  )
}

export default TopBar